// namespace suffix

export const ROOM_NAMESPACE_SUFFIX = 'room-';

// actions

export const ACTION_NAVIGATE = 'actions:navigate';

export const ACTION_TOGGLE_STORY = 'actions:toggleStory';
export const ACTION_TOGGLE_STICK = 'actions:toggleStick';
export const ACTION_TOGGLE_CAMERA_SYNC = 'actions:toggleCameraSync';

// sync
export const SYNC_GET_VIEW = 'sync:getView';
export const SYNC_VIEW = 'sync:view';

export const SYNC_GET_CAMERA = 'sync:getCamera';
export const SYNC_CAMERA = 'sync:camera';
export const SYNC_STICK = 'sync:stick';
export const SYNC_UPDATE_STATE = 'sync:updateState';
export const SYNC_GET_STATE = 'sync:getState';

